import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components";
import { Radio } from "@/components/Radio/Radio";

import { ContactSelectType } from "../schema/contacts";

interface SelectScopeModalProps {
	/** Total rows behind the current filter — what "All" would select. */
	itemCount?: number;
	limit: number;
	prepSelectType: ContactSelectType;
	setPrepSelectType: (value: ContactSelectType) => void;
	onConfirm: () => void;
	onClose: () => void;
}

/**
 * "Select all on this page, or everything the filter matches?" — the choice the
 * contacts tables offer once the header checkbox is used.
 */
export const SelectScopeModal: FunctionComponent<SelectScopeModalProps> = ({
	itemCount,
	limit,
	prepSelectType,
	setPrepSelectType,
	onConfirm,
	onClose,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`contacts.${key}`);

	const currentPageCount = itemCount && itemCount < limit ? itemCount : limit;

	return (
		<Modal
			handleClose={onClose}
			handleSave={onConfirm}
			isOpened
			size="xs"
			submitButtonText={t("basics.confirm")}
			title={ts("select")}
		>
			<div className="flex flex-col items-start gap-4">
				<Radio
					isChecked={prepSelectType === ContactSelectType.ALL}
					onChange={() => setPrepSelectType(ContactSelectType.ALL)}
				>
					<>
						{ts("all")}{" "}
						<span className="text-xs bg-placeholder text-white ml-2 px-2 py-1 rounded-md">
							{itemCount}
						</span>
					</>
				</Radio>
				<Radio
					isChecked={prepSelectType === ContactSelectType.CURRENT_PAGE}
					onChange={() => setPrepSelectType(ContactSelectType.CURRENT_PAGE)}
				>
					<>
						{ts("currentPage")}{" "}
						<span className="text-xs bg-placeholder text-white ml-2 px-2 py-1 rounded-md">
							{currentPageCount}
						</span>
					</>
				</Radio>
			</div>
		</Modal>
	);
};
